import emailjs from "@emailjs/browser";

const sendEmail = async (email) => {
  return await emailjs.send(
    "service_rentlyContactUs",
    "template_rw7kizg",
    {
      from_name: email.name,
      from_email: email.email,
      message: email.message,
      to_name: "rently buzz",
    },
    "e7acsGcFDcXJu0WtQ"
  );
};

export default sendEmail;
